<form [formGroup]="form">

	<app-modular-form-control-input name="name"/>

	<app-invalid-feedback></app-invalid-feedback>
</form>
